import { render, staticRenderFns } from "./general.vue?vue&type=template&id=6579bc4a"
import script from "./general.vue?vue&type=script&lang=js"
export * from "./general.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExpansionPanels: require('/home/runner/work/frontpages/frontpages/component-library/src/components/molecules/accordion/expansion-panels.vue').default})
